import { Component, OnInit, Input } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { RepairDiagramDialogComponent } from 'app/modules/app-components/repair-diagram-dialog/repair-diagram-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

import { CalculationService, DataService, HelperService, HTTPService, SocketService } from 'app/services';
import { units } from 'app/constants';
import { round } from 'lodash';
import { currency } from 'app/constants/currency.constants';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddonServiceDialogComponent } from 'app/modules/estimate/components/addon-service-dialog/addon-service-dialog.component';

@Component({
  selector: 'app-motor-service-enhanced-new-gen',
  templateUrl: './motor-service-enhanced-new-gen.component.html',
  styleUrls: ['./motor-service-enhanced-new-gen.component.scss'],
})
export class MotorServiceEnhancedNewGenComponent implements OnInit {
  @Input() orderStatus: string = '';
  @Input() selectedMotorServicesNewGen: any = {};
  @Input() motorVehicle: any = {};
  @Input() motorVehicleId: string = '';
  @Input() query: string = '';
  @Input() isMotorServiceEnabled: boolean = false;
  @Input() isRepairDiagramEnabled: boolean = false;
  @Input() isServiceLookup: boolean = false;
  @Input() confirmationTitle: string = '';
  @Input() confirmationContent: string = '';
  @Input() pricings: any = {};
  @Input() itemSettings: any = {};
  @Input() customFleetSettings: any = {};
  @Input() vehicle: any = {};

  usd: string = currency.USD;
  callTimestamp: number = 0;
  motorCategories: any[] = [];
  motorSubCategories: any[] = [];
  selectedCategory: any = null;
  selectedSubCategory: any = null;

  selectedGroup: any = null;
  applications: any[] = [];
  systemsCount: any = {};
  groupsCount: any = {};
  isMotorServiceLoading: boolean = true;
  socketListener: Subject<boolean> = new Subject<boolean>();
  dataListener: Subscription;
  vehicleAge: number = 0;
  // vehicle: any = {};
  socketId: any = '';
  focus: any = {};
  motorAdditionalServiceLoading: any = {};
  motorIncludedOperationLoading: any = {};
  additionalCannedServices: any = {};
  motorIncludedServices: any = {};
  units: any = units;
  numberObj = Number;
  addServiceTransition: any = {};
  itemsPerPage: number = 15;
  pageIndex: number = 0;
  totalPages: number = 0;
  showMore: boolean = false;
  isMoreLoading: boolean = false;
  defaultTax: any = {
    isTaxablePart: false,
    isTaxableLabor: false
  }

  constructor(
    private calculationService: CalculationService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private dataService: DataService,
    private socketService: SocketService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    const isMultiLocationEnabled = this.helperService.getCompany()?.isMultiLocationEnabled;
    if (isMultiLocationEnabled) {
      this.httpService.getUpdateLocationSettings(['isTaxablePart', 'isTaxableLabor']).then(
        (location: any) => {
          if (location?.appsettings) {
            this.defaultTax = {
              isTaxablePart: location.appsettings.isTaxablePart,
              isTaxableLabor: location.appsettings.isTaxableLabor,
            }
          }
        },
        (err) => {}
      );
    } else {
      this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then(
        (company) => {
          this.defaultTax = {
            isTaxablePart: company.appsettings.isTaxablePart,
            isTaxableLabor: company.appsettings.isTaxableLabor,
          }
        },
        (err) => {}
      );
    }
  }

  ngOnChanges(change: any) {
    const { motorVehicleId } = change;
    const { query } = change;

    if (query && query?.previousValue?.length && !query?.currenctValue?.length) {
      this.applications = [];
      if (this.selectedCategory?.category) {
        this.getMotorSubCategory()
      } else {
        this.getMotorCategory()
      }
    }

    if (motorVehicleId) {
      if (!motorVehicleId.previousValue && motorVehicleId.currentValue) {
        this.initializeMotorServices();
      } else {
        this.setDataService();
      }
    }
  }

  ngOnDestroy() {
    if (this.socketListener) {
      this.socketListener.unsubscribe();
    }

    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  initializeMotorServices() {
    this.setSockets();
    this.setDataService();
    this.getMotorCategory();
  }

  goBackToCategory() {
    this.selectedCategory = null;
    this.selectedSubCategory = '';
    this.selectedGroup = null;
    this.applications = [];
    this.pageIndex = 0;
    this.totalPages = 0;
    this.getMotorCategory();
  }

  getMotorSubCategory(isSubSelected = false) {
    if (isSubSelected) {
      this.selectedSubCategory = this.selectedGroup?.category || '';
    } else {
      this.selectedSubCategory = 'All';
    }
    const { vehicleId } = this.vehicle;
    const query = `selectedCategory=${encodeURIComponent(this.selectedCategory?.category) || 'all'}&search=${encodeURIComponent(this.query)}`;

    this.isMotorServiceLoading = !this.pageIndex;
    this.isMoreLoading = !!this.pageIndex;
    this.httpService
      .getMotorSubCategoriesNewGen(vehicleId, query)
      .then(
        (res) => {
          if (this.selectedCategory?.category?.toLowerCase() !== 'all') {
            if (this.query.length) {
              this.motorSubCategories = res;
            } else {
              this.motorSubCategories = res.filter(res => res.total);
            }
          } else {
            this.motorCategories = res;
          }
          this.getMotorCategoryService();
          // this.socketId = res.socketId;
        },
        (err) => {
          this.isMotorServiceLoading = false;
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        // this.isMoreLoading = false;
      });
  }

  getMotorCategory() {
    this.isMotorServiceLoading = true;
    if (this.motorVehicle && this.motorVehicle.Year) {
      this.vehicleAge = new Date().getFullYear() - this.motorVehicle.Year;
    }

    this.httpService
      .getMotorCategoriesNewGen(this.vehicle?.vehicleId, this.selectedCategory?.category, this.query)
      .then(
        (res) => {
          if (res) {
            if (this.query.length) {
              this.motorCategories = res;
            } else {
              this.motorCategories = res.filter(res => res.total);
            }
            if (this.query?.length) {
              this.getMotorCategoryService();
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        if (!this.query?.length) {
          this.isMotorServiceLoading = false;
        }
      });
  }

  getMotorCategoryService() {
    const { vehicleId } = this.vehicle;
    if (this.query?.length > 0) {
      this.applications = [];
    }
    const query = `selectedCategory=${encodeURIComponent(this.selectedCategory?.category) || 'all'}&selectedSubCategory=${encodeURIComponent(this.selectedSubCategory || 'all')}&search=${encodeURIComponent(this.query)}&limit=${this.itemsPerPage}&skip=${this.pageIndex * this.itemsPerPage}`;

    this.isMotorServiceLoading = !this.pageIndex;
    this.isMoreLoading = !!this.pageIndex;
    this.showMore = false;
    this.httpService
      .getMotorCategoriesServiceNewGen(vehicleId, query)
      .then(
        (res) => {
          if (res) {
            let dataLength = res?.reduce((acc, cur) => {
              acc += cur?.data?.length ?? 0
              return acc;
            }, 0)
            dataLength = res?.reduce((acc, cur) => {
              acc += cur?.data[0]?.additionalServices?.length ?? 0
              return acc;
            }, dataLength)
            this.totalPages = Math.ceil(dataLength / 15);
            this.showMore = dataLength >= 15 ? true : false;
            if (!this.isMoreLoading) {
              this.applications = [];
            }
            this.setMotorServiceGen(res);
          }
          // this.socketId = res.socketId;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isMotorServiceLoading = false;
        this.isMoreLoading = false;
      });
  }

  makeItemObject(motorItem: any, type: string, attributes: any, systemId: string, isOneSide: boolean) {
    let { DisplayName } = motorItem;
    const { Items, Position, Taxonomy, Qualifiers, ApplicationID, AttributeMappings } = motorItem;
    const attrMap = this.helperService.getMappedAttribute(attributes);
    let Item: any;

    if (Items && Items.length) {
      [Item] = Items && Items.filter(({ IsActive }) => IsActive);
    }

    if (!DisplayName && Taxonomy && Taxonomy.LiteralName) {
      DisplayName = Taxonomy.LiteralName;
    }

    let notes = '',
      count = 0,
      code = '',
      price = 0;

    let qualifiers = Qualifiers.filter(({ IsActive }) => IsActive !== false);
    let unitOfMeasuring = '';

    if (Item) {
      const { Grade, Notes, PartNumber, Quantity = 0, UnitOfMeasure, PricingFamilies } = Item;

      count = Quantity;
      code = PartNumber;
      unitOfMeasuring = UnitOfMeasure;

      if (!Quantity || Quantity === 0 || isOneSide) {
        count = 1;
      }

      if (Notes && Notes.length) {
        Notes.forEach(({ Text }) => {
          notes += Text;
        });
      }

      if (Grade && Grade.Description && !notes.includes(Grade.Description)) {
        notes = `${Grade.Description}\n${notes}`;
      }

      const [PricingFamily] = PricingFamilies;

      if (PricingFamily && PricingFamily.Pricing && PricingFamily.Pricing.length) {
        price = PricingFamily.Pricing[0].Price || 0;
      }
    }

    const item: any = {
      code,
      type,
      count,
      actualLaborTime: count,
      defaultCount: count,
      cost: this.calculationService.calculatingMotorPartCost(price, this.itemSettings.part.pricing),
      price,
      status: true,
      _id: 'no-id',
      title: DisplayName,
      description: notes.trim(),
      itemSource: 'Motor',
      subTotal: round((price * count), 2),
      itemSourceId: ApplicationID,
      qboId: this.itemSettings.part.qboId,
      isTaxable: this.itemSettings.part.isTaxable,
      commissionable: this.itemSettings.part.commissionable,
      displayHoursOnOrder: this.itemSettings.part.displayHoursOnOrder,
      displayDescOnOrder: this.itemSettings.part.displayDescOnOrder,
      subheading: '',
      tags: [],
      unitOfMeasuring: '',
    };

    item.quantity = this.helperService.renderItemQuantity(item);

    if (this.itemSettings.part && this.itemSettings.part.pricing && this.itemSettings.part.pricing._id) {
      item.pricing = {
        pricingId: this.itemSettings.part.pricing._id,
        name: this.itemSettings.part.pricing.name,
      };
    }

    if (this.customFleetSettings) {
      const { isPricingMatrixOverride, customPartPricingMatrix } = this.customFleetSettings;

      if (isPricingMatrixOverride && customPartPricingMatrix) {
        item.pricing = { pricingId: customPartPricingMatrix.pricingId, name: customPartPricingMatrix.name };
        item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, customPartPricingMatrix);
      }
    }

    if (unitOfMeasuring) {
      item.unitOfMeasuring = unitOfMeasuring.toLowerCase();
    }

    if (this.selectedMotorServicesNewGen[systemId]) {
      item.count = Number(this.selectedMotorServicesNewGen[systemId].itemCount[item.itemSourceId]);

      item.subTotal = item.price * item.count;
    }

    if (this.itemSettings.labor.motorTag) {
      item.tags.push(this.itemSettings.part.motorTag);
    }

    if (Position && Position.Name && Position.Name !== 'N/A') {
      if (code && code !== 'NA' && code !== 'NSS') {
        item.subheading = `#${code}`;
      }

      if (Position.Name) {
        item.subheading += `${code ? ' - ' : ''}${Position.Name}`;
      }
    }

    if (qualifiers && qualifiers.length) {
      qualifiers.forEach(({ Description }) => {
        if (Description) {
          item.subheading += `${item.subheading ? ' - ' : ''}${Description}`;
        }
      });
    }

    if (AttributeMappings && AttributeMappings.length) {
      AttributeMappings.forEach((attr: any) => {
        if (attrMap[attr.Type] && attrMap[attr.Type][attr.ID]) {
          const data = attrMap[attr.Type][attr.ID];

          if (attr.Type === 'BS' && data) {
            item.subheading += `${item.subheading ? ' - ' : ''}Body Style: ${data.DoorCount} Door - ${data.Type}`;
          }

          if (attr.Type === 'BR' && data) {
            item.subheading += `${item.subheading ? ' - ' : ''}Brake: ${data.FrontType ? `${data.FrontType}/` : ''}${data.RearType ? `${data.RearType}` : ''}${data.ABS ? `/${data.ABS}` : ''}`;
          }
        }
      });
    }

    item.description = `${item.subheading} ${item.description}`;

    return item;
  }

  async addToEstmateMotor(service: any, isAdded: boolean, handleSelectAll: Function, event: any, showConfirmation: boolean = true, index: number = -1, parentService?) {
    let additionalServicesIdsInParent = [];
    let additionalServicesIds = [];
    for (const key in this.selectedMotorServicesNewGen) {
      const ids = this.selectedMotorServicesNewGen[key]?.additionalServices?.map(service => service._id);
      if (ids?.length) {
        additionalServicesIdsInParent = [...additionalServicesIdsInParent, ...ids];
      }
    }
    additionalServicesIds = service?.items?.map((item) => (item._id));
    const selectedIds: any = Object.values(this.selectedMotorServicesNewGen)?.reduce((acc: any, val: any) => {
      const ids = val.items?.map(item => item._id)
      if (ids?.length) {
        acc = [...acc, ...ids]
      }
      return acc;
    }, []);
    const isServiceSelected = selectedIds?.filter(item => additionalServicesIds?.includes(item))?.length || 0;
    const isPrimarySelected = Object.keys(this.selectedMotorServicesNewGen)?.length && additionalServicesIdsInParent.includes(service._id);
    if (!isPrimarySelected && parentService && !isServiceSelected) {
      const addService = await this.openAddonConfirmationModal(parentService.title, service.title);
      if (!addService) {
        this.helperService.setConfirmationStatus(addService, event?.data?._id)
        return;
      }
    }

    event.stopPropagation();
    let { applicationId, items } = service;
    items = items.map(item => ({ ...item, isTaxable: item.type === 'parts' ? this.defaultTax.isTaxablePart : this.defaultTax.isTaxableLabor }))
    if (isAdded && showConfirmation && this.hasQuantityChanged(service)) {
      this.openConfirmationModal(service, isAdded, handleSelectAll, event, index);
      return;
    }

    if (applicationId) {
      this.addServiceTransition[applicationId] = true;
      setTimeout(() => {
        try {
          this.addServiceTransition[applicationId] = false;
        } catch (err) { }
      }, 500);

      if (!isAdded) {
        this.selectedMotorServicesNewGen[applicationId] = {
          ...service,
          items: items.filter(({ type }) => type !== 'parts'),
          extra: { isAdded: true },
        };
      } else {
        delete this.selectedMotorServicesNewGen[applicationId];
      }
    }

    handleSelectAll(!isAdded ? 'select' : 'deselect', event, true, true);
  }

  handleFocus(itemId: string, isDisabled: boolean) {
    if (isDisabled) {
      return;
    }

    this.focus = { [itemId]: true };
  }

  handleInputClick(item: any, isDisabled: boolean) {
    if (isDisabled) {
      const unit = item.type === 'fluids' ? units.fluids[item.unitOfMeasuring] : units[item.type];

      this.helperService.showToaster('error', `Select the service to edit the ${unit}`);
      return;
    }
  }

  handleBlur(systemId: string, outerIdx, innerIdx, itmTouched, newCount, middleIdx?) {
    let itmIdx;
    let defaultCount;
    let price;
    let newPrice;
    let targetArr;
    if (middleIdx !== null && middleIdx !== undefined) {
      targetArr = this.applications[outerIdx]?.items[middleIdx]?.additionalServices[innerIdx]?.items;
    } else {
      targetArr = this.applications[outerIdx]?.items[innerIdx]?.items;
    }
    if (targetArr) {
      itmIdx = targetArr.findIndex(itm => itm._id === itmTouched._id)
      targetArr[itmIdx].count = newCount
      defaultCount = Number(targetArr[itmIdx].defaultCount);
      price = targetArr[itmIdx].defaultPrice;
      newPrice = (newCount / defaultCount) * price;
      targetArr[itmIdx].price = newPrice;
      targetArr[itmIdx].total = newPrice;
      let laborTotal = 0;
      let partsTotal = 0;
      targetArr?.forEach(itm => {
        if (itm.type === 'labor') {
          laborTotal = itm.total;
          itm.costEstimatedHours = itm.count;
          itm.billableHours = itm.count;
          itm.cost = itm.costEstimatedHours * this.pricings[itm.laborType].cost;
        }
        if (itm.type === 'parts') {
          partsTotal += itm.total;
        }
      })
      if (middleIdx !== null && middleIdx !== undefined) {
        this.applications[outerIdx].items[middleIdx].additionalServices[innerIdx].serviceTotal = {
          labor: laborTotal,
          parts: partsTotal,
          total: laborTotal + partsTotal,
        };
        const count = this.applications[outerIdx].items[middleIdx].additionalServices[innerIdx].items.forEach(application => {
          const count = application.count;
          if (typeof count === 'string') {
            application.count = parseFloat(count);
          }
        })
      } else {
        this.applications[outerIdx].items[innerIdx].serviceTotal = {
          labor: laborTotal,
          parts: partsTotal,
          total: laborTotal + partsTotal,
        };
        this.applications[outerIdx].items[innerIdx].items.forEach(application => {
          const count = application.count;
          if (typeof count === 'string') {
            application.count = parseFloat(count);
          }
        })
      }
    }
    this.focus[`${systemId}${outerIdx}`] = false;
  }

  handleChange(systemId: string, itemDefaultId: string, value: any, itemId: string) {
    if (this.selectedMotorServicesNewGen[systemId] && this.selectedMotorServicesNewGen[systemId].itemCount) {
      this.selectedMotorServicesNewGen[systemId].itemCount[itemDefaultId] = value;
      const targetId = this.selectedMotorServicesNewGen[systemId].items.findIndex(itm => itm._id === itemId);
      if (targetId >= 0) {
        const newQuantity = parseFloat(value);
        const type = this.selectedMotorServicesNewGen[systemId].items[targetId].type
        const defaultCount = this.selectedMotorServicesNewGen[systemId].items[targetId].defaultCount
        const defaultPrice = this.selectedMotorServicesNewGen[systemId].items[targetId].defaultPrice
        const newPrice = Math.round((newQuantity / defaultCount * defaultPrice) * 100) / 100;
        if (type === 'parts') {
          this.selectedMotorServicesNewGen[systemId].items[targetId].count = newQuantity;
          this.selectedMotorServicesNewGen[systemId].items[targetId].price = newPrice;
          this.selectedMotorServicesNewGen[systemId].items[targetId].total = newPrice;
        } else {
          this.selectedMotorServicesNewGen[systemId].items[targetId].count = newQuantity;
          this.selectedMotorServicesNewGen[systemId].items[targetId].total = newPrice;
        }
      }
    }
  }

  handleRevertManualHour(systemId: string, outerIdx, innerIdx, itmTouched, value: any, middleIdx) {
    event.stopPropagation();
    event.preventDefault();
    if (this.selectedMotorServicesNewGen[systemId] && this.selectedMotorServicesNewGen[systemId].itemCount) {
      this.handleBlur(systemId, outerIdx, innerIdx, itmTouched, itmTouched.defaultCount, middleIdx);
      this.handleChange(systemId, innerIdx, itmTouched.defaultCount.toString(), itmTouched._id)
    }
  }

  handleSelectCategory(category: any, itemCount: number) {
    if (this.query.length > 2 && !itemCount) {
      return;
    }

    this.pageIndex = 0;
    this.totalPages = 0;

    this.selectedCategory = category;
    this.getMotorSubCategory();
  }

  handleSelectGroup(group: any, itemCount: number) {
    if (this.query.length > 2 && !itemCount) {
      return;
    }
    this.applications = [];
    this.pageIndex = 0;
    this.totalPages = 0;
    this.selectedGroup = group;
    this.getMotorSubCategory(true);
  }

  hasQuantityChanged = (service: any) => {
    let hasChanged = false;

    const { itemCount, defaultItemCount } = service;
    if (itemCount) {
      const keys = Object.keys(itemCount);

      for (let i = 0; i < keys.length; i++) {
        if (Number(itemCount[keys[i]]) !== Number(defaultItemCount[keys[i]])) {
          hasChanged = true;
          break;
        }
      }
    }
    return hasChanged;
  };

  handleReset({ service, index }) {
    const { defaultItemCount, items } = service;

    this.applications[index].itemCount = this.helperService.deepCopy(defaultItemCount);
    this.applications[index].serviceTotal = {
      labor: 0,
      parts: 0,
      fluids: 0,
      total: 0,
    };
    this.applications[index].count = {
      labor: 0,
      parts: 0,
      fluids: 0,
      total: 0,
    };

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const count = defaultItemCount[item.itemSourceId];
      this.applications[index].items[i].count = count;

      if (item.type === 'labor') {
        this.applications[index].items[i].costEstimatedHours = count;
        this.applications[index].items[i].billableHours = count;
        this.applications[index].items[i].cost = count * this.pricings[item.laborType].cost;
      }
      if (item.type === 'part') {
        item.type = 'parts'
      }

      this.applications[index].items[i].subTotal = item.price * count;
      this.applications[index].serviceTotal[item.type] += item.subTotal;
      this.applications[index].serviceTotal.total += item.subTotal;
      this.applications[index].count[item.type] += count;
    }
  }

  async handleSelectChangeMotor(event: any, application: any, service?: any) {
    let { list } = event;
    const { applicationId } = application;

    if (service && event?.isChecked) {
      let additionalServicesIds = [];
      for (const key in this.selectedMotorServicesNewGen) {
        const ids = this.selectedMotorServicesNewGen[key]?.additionalServices?.map(service => service._id);
        if (ids?.length) {
          additionalServicesIds = [...additionalServicesIds, ...ids];
        }
      }
      const isPrimarySelected = Object.keys(this.selectedMotorServicesNewGen)?.length && additionalServicesIds.includes(application._id);
      if (!isPrimarySelected) {
        const addService = await this.openAddonConfirmationModal(service.title, application.title);
        if (!addService) {
          this.helperService.setConfirmationStatus(addService, event?.data?._id)
          return;
        }
      }
    }

    if (list.length) {
      list = list.map(item => ({ ...item, isTaxable: item.type === 'parts' ? this.defaultTax.isTaxablePart : this.defaultTax.isTaxableLabor }))
      this.selectedMotorServicesNewGen[applicationId] = {
        ...application,
        ...this.selectedMotorServicesNewGen[applicationId],
        extra: { isAdded: true },
        items: this.helperService.deepCopy(list),
      };
    } else {
      delete this.selectedMotorServicesNewGen[applicationId];
    }
  }

  handleExpandMotorService(isExpanded: boolean, application: any) {
    if (isExpanded) {
      const { CountryID, EngineID, SubModelID } = this.motorVehicle;
      const applicationId = application.ApplicationID;
      const query = {
        EN: EngineID,
        CO: CountryID,
        SM: SubModelID,
        search: this.query,
        motorVehicleId: this.motorVehicleId,
        applicationId: applicationId,
        systemId: this.selectedCategory?.SystemID,
        groupId: this.selectedGroup && this.selectedGroup.GroupID,
      };

      if (this.selectedCategory?.SystemID === 'all') {
        delete query.systemId;
        delete query.groupId;
      }

      this.callTimestamp = Date.now();
    }
  }

  openConfirmationModal(service: any, isAdded: boolean, handleSelectAll: Function, event: any, index: number) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        title: this.confirmationTitle,
        message: this.confirmationContent,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.addToEstmateMotor(service, isAdded, handleSelectAll, event, false);
        this.handleReset({ service, index });
      }

      onClose.unsubscribe();
    });
  }

  openAddonConfirmationModal(primaryService: string, additionalService: string): Promise<boolean> {
    return new Promise((resolve) => {
      const ref = this.dialogService.open(AddonServiceDialogComponent, {
        width: '50%',
        styleClass: 'small-heading-dialog addon-confirmation',
        showHeader: false,
        data: {
          addOnName: additionalService,
          primaryServiceName: primaryService
        },
      });
      const onClose = ref.onClose.subscribe(({ isSuccess }) => {
        resolve(isSuccess)
        onClose.unsubscribe();
      });
    })
  }

  setMotorServiceGen(motorService: any) {
    motorService.forEach((application: any, applicationIndex) => {

      // const { operation, laborTime, source, groupName } = key[index];
      let DisplayName = application.name || '';
      const item: any = {
        DisplayName,
        // applicationId: application.applicationId,
        description: application.description,
        serviceTotal: {},
        itemCount: {},
        defaultItemCount: {},
        items: application.data,
      };

      // application.subheading = '';
      item.applicationId = application.applicationId;
      item.notes = application.description



      item?.items?.forEach((element, index) => {
        element?.additionalServices?.forEach(ele => {
          let laborTotal = 0;
          let partsTotal = 0;

          let time = 0;
          let title = '';
          if (ele.source === 'labor') {
            time = ele.laborTime;
            title = ele.name;
          } else if (ele.source === 'part') {
            title = ele.component;
            if (ele.price.includes("$")) {
              ele.price = parseFloat(ele.price.replace("$", ""));
            }
          }

          const laborItem: any = {
            cost: 0,
            price: ele.price,
            laborType: 'General',
            total: 0,
            billRate: 0,
            actualLaborTime: time,
            motorMarkup: 0,
            count: ele.laborTime || 0,
            _id: ele._id,
            status: true,
            type: ele.source,
            title: title,
            description: ele.description,
            billableHours: time,
            itemSource: 'Motor',
            costEstimatedHours: time,
            itemSourceId: ele._id + element.applicationId,
            qboId: this.itemSettings.labor.qboId,
            isTaxable: this.itemSettings.labor.isTaxable,
            commissionable: this.itemSettings.labor.commissionable,
            displayHoursOnOrder: this.itemSettings.labor.displayHoursOnOrder,
            displayDescOnOrder: this.itemSettings.labor.displayDescOnOrder,
            tags: [],
            subheading: '',
          };
          ele.itemCount = {};
          ele.defaultItemCount = {};
          ele.itemCount[laborItem.itemSourceId] = laborItem.count;
          ele.defaultItemCount[laborItem.itemSourceId] = laborItem.count;
          if (this.itemSettings.labor.motorTag) {
            laborItem.tags.push(this.itemSettings.labor.motorTag);
          }

          if (this.itemSettings?.motorLaborTimeMarkup?._id) {
            const { value, markup } = this.calculationService.calculateLaborMarkupTime(this.vehicleAge, parseFloat(laborItem.actualLaborTime), this.itemSettings.motorLaborTimeMarkup);

            laborItem.count = value;
            laborItem.motorMarkup = markup;
          }

          const skillType = ['General', 'Precision', 'Maintenance'];
          if (skillType.indexOf(laborItem.laborType) !== -1) {
            if (this.pricings[laborItem.laborType]) {
              const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;
              let billRate = this.pricings[laborItem.laborType].price;
              let pricing = this.pricings[laborItem.laborType].pricing;

              if (isLaborRateOverride && customLaborRate) {
                pricing = customLaborRate;
                billRate = customLaborRate && customLaborRate.rate;
              }
              laborItem.cost = this.pricings[laborItem.laborType].cost * laborItem.costEstimatedHours;
              laborItem.billRate = billRate;
              if (laborItem.type !== 'part')
                laborItem.price = laborItem.billRate;
              laborItem.total = laborItem.billRate * laborItem.count;
              laborItem.pricing = pricing;
            }
          } else {
            if (this.pricings.General) {
              const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;
              let billRate = this.pricings.General.price;
              let pricing = this.pricings.General.pricing;

              if (isLaborRateOverride && customLaborRate) {
                pricing = customLaborRate;
                billRate = customLaborRate && customLaborRate.rate;
              }

              laborItem.cost = this.pricings.General.cost * laborItem.costEstimatedHours;
              laborItem.billRate = billRate;
              if (laborItem.type !== 'part')
                laborItem.price = laborItem.billRate;
              laborItem.total = laborItem.billRate * laborItem.count;
              laborItem.pricing = pricing;
            }
          }

          ele?.items?.forEach(itm => {
            if (itm.type === 'labor') {
              laborTotal += laborItem.total;
            }
            if (itm.type === 'parts') {
              partsTotal += itm.total;
            }
          })

          if (this.selectedMotorServicesNewGen[ele.applicationId + element.applicationId]) {
            laborItem.count = Number(this.selectedMotorServicesNewGen[ele.applicationId + element.applicationId].itemCount[laborItem.itemSourceId]);
            laborItem.billableHours = laborItem.count;
            laborItem.costEstimatedHours = laborItem.count;
          }
          if (ele?.items[0]?.total !== null) {
            ele.items[0].total = laborItem?.total ?? 0;
            ele.items[0].count = laborItem?.count ?? 0;
          }
          ele.items = ele.items.map(itm => ({
            ...itm,
            title: itm.name,
            laborType: laborItem.laborType,
            price: itm.type !== 'parts' ? laborItem.price : itm.total,
            cost: laborItem.cost,
            billableHours: laborItem.billableHours,
            costEstimatedHours: laborItem.costEstimatedHours,
            status: true,
            description: itm.description,
            itemSource: 'Motor',
            defaultCount: itm.type === 'labor' ? laborItem.count : 1,
            defaultPrice: itm.total,
            tags: [{ name: 'MOTOR', color: '#009cdc' }],
            isAdditionalOperation: ele.isAdditionalOperation
          }))
          ele.serviceTotal = {
            labor: laborTotal,
            parts: partsTotal,
            total: laborTotal + partsTotal,
          };
          Object.assign(ele, laborItem);
        })
      });
      item?.items?.forEach((element, index) => {
        let laborTotal = 0;
        let partsTotal = 0;
        let time = 0;
        let title = '';
        if (element.source === 'labor') {
          time = element.laborTime;
          title = element.name;
        } else if (element.source === 'part') {
          title = element.component;
          if (element.price.includes("$")) {
            element.price = parseFloat(element.price.replace("$", ""));
          }
        }

        const laborItem: any = {
          cost: 0,
          price: element.price,
          laborType: 'General',
          total: 0,
          billRate: 0,
          actualLaborTime: time,
          motorMarkup: 0,
          count: element.laborTime || 0,
          _id: element._id,
          status: true,
          type: element.source,
          title: title,
          description: element.description,
          billableHours: time,
          itemSource: 'Motor',
          costEstimatedHours: time,
          itemSourceId: element.applicationId,
          qboId: this.itemSettings.labor.qboId,
          isTaxable: this.itemSettings.labor.isTaxable,
          commissionable: this.itemSettings.labor.commissionable,
          displayHoursOnOrder: this.itemSettings.labor.displayHoursOnOrder,
          displayDescOnOrder: this.itemSettings.labor.displayDescOnOrder,
          tags: [],
          subheading: '',
        };
        element.itemCount = {};
        element.defaultItemCount = {};
        element.itemCount[laborItem.itemSourceId] = laborItem.count;
        element.defaultItemCount[laborItem.itemSourceId] = laborItem.count;

        if (this.itemSettings.labor.motorTag) {
          laborItem.tags.push(this.itemSettings.labor.motorTag);
        }

        if (this.itemSettings?.motorLaborTimeMarkup?._id) {
          const { value, markup } = this.calculationService.calculateLaborMarkupTime(this.vehicleAge, parseFloat(laborItem.actualLaborTime), this.itemSettings.motorLaborTimeMarkup);

          laborItem.count = value
          laborItem.motorMarkup = markup;
        }

        const skillType = ['General', 'Precision', 'Maintenance'];
        if (skillType.indexOf(laborItem.laborType) !== -1) {
          if (this.pricings[laborItem.laborType]) {
            const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;
            let billRate = this.pricings[laborItem.laborType].price;
            let pricing = this.pricings[laborItem.laborType].pricing;

            if (isLaborRateOverride && customLaborRate) {
              pricing = customLaborRate;
              billRate = customLaborRate && customLaborRate.rate;
            }
            laborItem.cost = this.pricings[laborItem.laborType].cost * laborItem.costEstimatedHours;
            laborItem.billRate = billRate;
            if (laborItem.type !== 'part')
              laborItem.price = laborItem.billRate;
            laborItem.total = laborItem.billRate * laborItem.count;
            laborItem.pricing = pricing;
          }
        } else {
          if (this.pricings.General) {
            const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;
            let billRate = this.pricings.General.price;
            let pricing = this.pricings.General.pricing;

            if (isLaborRateOverride && customLaborRate) {
              pricing = customLaborRate;
              billRate = customLaborRate && customLaborRate.rate;
            }

            laborItem.cost = this.pricings.General.cost * laborItem.costEstimatedHours;
            laborItem.billRate = billRate;
            if (laborItem.type !== 'part')
              laborItem.price = laborItem.billRate;
            laborItem.total = laborItem.billRate * laborItem.count;
            laborItem.pricing = pricing;
          }
        }

        if (laborItem.type === 'labor') {
          laborTotal += laborItem.total;
        }
        if (laborItem.type === 'parts') {
          partsTotal += laborItem.total;
        }

        if (this.selectedMotorServicesNewGen[item.applicationId]) {
          laborItem.count = Number(this.selectedMotorServicesNewGen[item.applicationId].itemCount[laborItem.itemSourceId]);
          laborItem.billableHours = laborItem.count;
          laborItem.costEstimatedHours = laborItem.count;
        }
        if (element?.items[0]?.total !== null) {
          element.items[0].motorMarkup = laborItem.motorMarkup;
          element.items[0].total = laborItem?.total ?? 0;
          element.items[0].count = laborItem?.count ?? 0;
        }
        element?.items?.forEach(itm => {
          if (itm.type === 'labor') {
            laborTotal = laborItem.total;
          }
          if (itm.type === 'parts') {
            partsTotal += itm.total;
          }
        })
        element.items = element.items.map(itm => ({
          ...itm,
          title: itm.name,
          laborType: laborItem.laborType,
          price: itm.type !== 'parts' ? laborItem.price : itm.total,
          cost: laborItem.cost,
          billableHours: laborItem.billableHours,
          costEstimatedHours: laborItem.costEstimatedHours,
          status: true,
          description: itm.description,
          itemSource: 'Motor',
          defaultCount: itm.type === 'labor' ? laborItem.count : 1,
          defaultPrice: itm.total,
          tags: [{ name: 'MOTOR', color: '#009cdc' }],
          isAdditionalOperation: element.isAdditionalOperation
        }))

        element.serviceTotal = {
          labor: laborTotal,
          parts: partsTotal,
          total: laborTotal + partsTotal,
        };
        Object.assign(element, laborItem);
      });

      this.applications.push(item);
    });
  }

  setSockets() {
    const { userId } = this.helperService.getCompany();

    if (this.socketListener) {
      this.socketListener.unsubscribe();
    }
    this.socketListener = new Subject<boolean>();
    this.socketService
      .socketOn(`motor-service-item${this.motorVehicleId}${userId}`)
      .pipe(takeUntil(this.socketListener))
      .subscribe((motorServiceData) => {
        if (motorServiceData) {
          const { data, socketId, systemID, applicationId, vehicleBaseId } = motorServiceData;
          const { parts, fluids } = data;
          const systemId = this.selectedCategory?.SystemID;

          if (socketId === this.socketId && `${vehicleBaseId}` === `${this.motorVehicleId}`) {
            if (`${systemId || ''}` === `${systemID}` || systemId === 'all') {
              for (let i = 0; i < this.applications.length; i++) {
                const application = this.applications[i];
                const { applicationId, isOneSide } = application;

                if (`${application.ApplicationID}` === `${applicationId}`) {
                  parts.Applications.forEach((application: any) => {
                    const item = this.makeItemObject(application, 'parts', parts.Attributes, applicationId, isOneSide);
                    this.applications[i].itemCount[item.itemSourceId] = item.count;
                    this.applications[i].defaultItemCount[item.itemSourceId] = item.defaultCount;
                    this.applications[i].items.push(item);
                  });

                  fluids.Applications.forEach((application: any) => {
                    const item = this.makeItemObject(application, 'fluids', parts.Attributes, applicationId, isOneSide);
                    this.applications[i].itemCount[item.itemSourceId] = item.count;
                    this.applications[i].defaultItemCount[item.itemSourceId] = item.defaultCount;
                    this.applications[i].items.push(item);
                  });

                  this.applications[i].serviceTotal = {
                    labor: 0,
                    parts: 0,
                    fluids: 0,
                    total: 0,
                  };
                  this.applications[i].count = {
                    labor: 0,
                    parts: 0,
                    fluids: 0,
                    total: 0,
                  };
                  this.applications[i].items.forEach(({ type, subTotal, count }) => {
                    this.applications[i].serviceTotal[type] += subTotal;
                    this.applications[i].serviceTotal.total += subTotal;
                    this.applications[i].count[type] += count;
                  });
                }
              }
            }
          }
        }
      });
  }

  setDataService() {
    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data.key === 'motor-on-search') {
        this.query = data.data.query;
        this.pageIndex = 0;
        this.totalPages = 0;
        if (this.query) {
          if (this.selectedCategory?.category) {
            this.getMotorSubCategory();
          } else {
            this.getMotorCategory();
          }
        }
      }
    });
  }

  // in motor gen4.5 we are not considering fluids for this release
  // setPartsFluidsForAdditionalService(parts: any, fluids: any, SapplicationID: string, applicationId: string, isOneSide: boolean) {
  //   let aIndex = -1;
  //   const additionalService = this.additionalCannedServices[applicationId];

  //   for (let i = 0; i < additionalService.length; i++) {
  //     if (additionalService[i].ApplicationID === applicationId) {
  //       aIndex = i;
  //     }
  //   }

  //   if (parts && parts.Applications && parts.Applications.length) {
  //     parts.Applications.forEach((application: any) => {
  //       const item = this.makeItemObject(application, 'parts', parts.Attributes, applicationId, isOneSide);

  //       if (aIndex !== -1 && this.additionalCannedServices[applicationId][aIndex]) {
  //         this.additionalCannedServices[applicationId][aIndex].itemCount[item.itemSourceId] = item.count;
  //         this.additionalCannedServices[applicationId][aIndex].defaultItemCount[item.itemSourceId] = item.defaultCount;
  //         this.additionalCannedServices[applicationId][aIndex].items.push(item);
  //       }
  //     });
  //   }

  //   if (fluids && fluids.Applications && fluids.Applications.length) {
  //     fluids.Applications.forEach((application: any) => {
  //       const item = this.makeItemObject(application, 'fluids', parts.Attributes, applicationId, isOneSide);

  //       if (aIndex !== -1 && this.additionalCannedServices[applicationId][aIndex]) {
  //         this.additionalCannedServices[applicationId][aIndex].itemCount[item.itemSourceId] = item.count;
  //         this.additionalCannedServices[applicationId][aIndex].defaultItemCount[item.itemSourceId] = item.defaultCount;
  //         this.additionalCannedServices[applicationId][aIndex].items.push(item);
  //       }
  //     });
  //   }
  // }

  setTooltip(itemCount: number, name: string) {
    if (this.query.length > 2 && !itemCount) {
      return `${name} has 0 matching results`;
    }

    return '';
  }

  setMotorTypeSettings(appsettings: any, motorTag: any) {
    const {
      pricingId,
      partPriceId,
      isTaxablePart,
      isTaxableLabor,
      isCommissionablePart,
      isCommissionableLabor,
      mBaseLaborCost,
      partQboItemRefId,
      laborQboItemRefId,
      percisionLaborCost,
      maintainenacePriceId,
      motorLaborTimeMarkup,
      percisionLaborPriceId,
      maintainenaceLaborCost,
      displayDescOnOrderPart,
      displayHoursOnOrderPart,
      displayDescOnOrderLabor,
      displayHoursOnOrderLabor,
    } = appsettings;

    if (pricingId) {
      this.pricings.General = {
        price: pricingId.rate,
        cost: mBaseLaborCost,
        pricing: {
          pricingId: pricingId._id,
          name: pricingId.name,
        },
      };
    }

    if (percisionLaborPriceId) {
      this.pricings.Precision = {
        price: percisionLaborPriceId.rate,
        cost: percisionLaborCost,
        pricing: {
          pricingId: percisionLaborPriceId._id,
          name: percisionLaborPriceId.name,
        },
      };
    }

    if (maintainenacePriceId) {
      this.pricings.Maintenance = {
        price: maintainenacePriceId.rate,
        cost: maintainenaceLaborCost,
        pricing: {
          pricingId: maintainenacePriceId._id,
          name: maintainenacePriceId.name,
        },
      };
    }
    this.itemSettings.part = {
      motorTag: motorTag,
      isTaxable: isTaxablePart,
      commissionable: isCommissionablePart,
      displayHoursOnOrder: displayHoursOnOrderPart,
      displayDescOnOrder: displayDescOnOrderPart,
      qboId: (partQboItemRefId && partQboItemRefId.qboId) || '',
      pricing: partPriceId,
    };
    this.itemSettings.labor = {
      motorTag: motorTag,
      isTaxable: isTaxableLabor,
      commissionable: isCommissionableLabor,
      displayHoursOnOrder: displayHoursOnOrderLabor,
      displayDescOnOrder: displayDescOnOrderLabor,
      qboId: (laborQboItemRefId && laborQboItemRefId.qboId) || '',
    };
    this.itemSettings.motorLaborTimeMarkup = motorLaborTimeMarkup;
  }

  setCount(systemId: string, itemSource: string, count: number) {
    if (this.selectedMotorServicesNewGen[systemId] && this.selectedMotorServicesNewGen[systemId].itemCount && this.selectedMotorServicesNewGen[systemId].itemCount[itemSource]) {
      return this.selectedMotorServicesNewGen[systemId].itemCount[itemSource];
    }

    return count;
  }

  openRepairDiagram(application: any, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    const { ApplicationID, DisplayName } = application;
    const { CountryID, EngineID, SubModelID } = this.motorVehicle;

    this.dialogService.open(RepairDiagramDialogComponent, {
      showHeader: false,
      styleClass: 'repair-diagram-dialog-ref',
      data: {
        displayName: DisplayName,
        options: {
          EN: EngineID,
          CO: CountryID,
          SM: SubModelID,
        },
        applicationId: ApplicationID,
        vehicleId: this.motorVehicleId,
      },
    });
  }

  showTooltip(actualLaborTime: number, markup: number, markUpQty) {
    return `Revert back to the Marked up value: ${Number(actualLaborTime)} * (1 + ${Number(markup)}/100) = ${Number(markUpQty)}`;
  }

  getMoreServices() {
    // if (this.pageIndex < this.totalPages - 1) {
    this.pageIndex++;
    this.getMotorSubCategory();
    // }
  }
}
